/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, SelectionModel } from '@gh/core-data';

export const BulkUpdateTaskType = createEnum('BULK_UPDATE_TASK_TYPE', {
  RecalculateComponent: 1,
  RecalculateHousePlan: 2,
  AddItemsComponent: 3,
  ReplaceItemComponent: 4,
  RemoveItemComponent: 5,
  AddItemsHousePlan: 6,
  ReplaceItemHousePlan: 7,
  RemoveItemHousePlan: 8,
  ReplaceFormulaHousePlan: 9,
  ExportHousePlan: 10,
});

export type BulkUpdateTaskType = EnumSet<typeof BulkUpdateTaskType>;

export const BulkUpdateTaskStatus = createEnum('BULK_UPDATE_TASK_STATUS', {
  Ready: 'READY',
  Processing: 'PROCESSING',
  Complete: 'COMPLETE',
  Error: 'ERROR',
});

export type BulkUpdateTaskStatus = EnumSet<typeof BulkUpdateTaskStatus>;

export type ButlListItemDto = {
  id: ID;
  type: string;
  entity: string;
  addedDate: Date;
  updatedDate: Date;
  lastMessage: String;
  attemptsRemain: number;
  status: string;
  statusValue: BulkUpdateTaskStatus;
};

export type ButlMessageDto = {
  resultMessage: string;
};

export enum BulkUpdateFunction {
  Add,
  Replace,
  Delete,
}

export enum BulkUpdateTarget {
  HousePlans,
  Components,
}

export type BulkUpdateHousePlanAddDto = {
  targetHousePlans: SelectionModel;
  items: ID[];
  components: ID[];
};

export type BulkUpdateComponentAddDto = {
  targetComponents: SelectionModel;
  items: ID[];
};

export type BulkUpdateItemComponentListItemDto = {
  id: ID;
  code: string;
  description: string;
  cost: number;
  quantity: number;
  costCenterCode: number;
  component: boolean;
};

export type BulkUpdateItemReplaceDto = {
  id: ID;
  code: string;
  uomId: string;
  isComponent?: boolean;
};

export type BulkUpdateHousePlanReplaceDto = {
  targetHousePlans: SelectionModel;
  allowUpdate: boolean;
  oldEntity: BulkUpdateItemReplaceDto;
  newEntity: BulkUpdateItemReplaceDto;
};

export type BulkUpdateComponentReplaceDto = {
  targetComponents: SelectionModel;
  allowUpdate: boolean;
  oldEntity: BulkUpdateItemReplaceDto;
  newEntity: BulkUpdateItemReplaceDto;
};

export type BulkUpdateHousePlanDeleteDto = {
  targetHousePlans: SelectionModel;
  items: ID[];
  components: ID[];
};

export type BulkUpdateComponentDeleteDto = {
  targetComponents: SelectionModel;
  items: ID[];
};

export type BulkUpdateReplaceInitDto = {
  allowUpdate: boolean;
};
